import React, { useEffect, useRef } from 'react'
import { View } from 'react-native'

import Alert from '@ui-kit/components/Alert'

export const StepValidationAlert = ({
  className,
  id,
  message,
}: {
  className?: string
  id: string
  message: string
}) => {
  const containerRef = useRef<View>(null)

  useEffect(() => {
    const node = containerRef.current as unknown as HTMLElement | null
    if (!node) {
      return
    }
    node.scrollIntoView({ behavior: 'smooth', block: 'center' })
    node.setAttribute('tabindex', '-1')
    node.focus({ preventScroll: true })
  }, [message])

  return (
    <View ref={containerRef} className={className} accessibilityRole="alert" accessible>
      <Alert id={id} message={message} variant="error" />
    </View>
  )
}
